/**
 * variant-fallback.js — Theme 214.0 (home 168, Head 96.0).
 * A body colour that has no variant beside the current picks (black body + black shin) carries data-fallback-values
 * (snippets/variant-main-picker.liquid). Before the picker reacts, check the picks of that variant in the other rows and
 * hand the clicked input its variant id, so the picker fetches a real combination and ?variant= follows.
 * Capture on window: component.js delegates `on:change` from document in the capture phase, and window runs first.
 * Only the body colour (option 1) carries the attributes, so a click on a crossed-out shin stays as Tinker does it.
 */
window.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.checked) return;
    const { fallbackValues, fallbackVariantId } = input.dataset;
    if (!fallbackValues || !fallbackVariantId) return;
    const picker = input.closest('variant-picker');
    if (!picker) return;

    fallbackValues.split('|').forEach((value, index) => {
      if (index === 0) return;
      const match = Array.from(picker.querySelectorAll(`input[data-input-id^="${index + 1}-"]`)).find(
        (other) => other instanceof HTMLInputElement && other.value === value
      );
      if (match instanceof HTMLInputElement && !match.checked) match.checked = true;
    });

    input.dataset.variantId = fallbackVariantId;
  },
  true
);
